import React from 'react'

import { useUsers } from '../_load/UsersLoader'
import UserListItem from './UserListItem'

const UsersList = () => {
  const users = useUsers()

  return users.map(item => <UserListItem key={item.id} item={item} />)
}

export default UsersList
